import React, { Component } from 'react';
import { Provider } from 'react-redux';
import { Store } from '../../redux/Store';
import { Row, Col, Form, Button, Modal } from 'react-bootstrap';
import { Elements, StripeProvider } from 'react-stripe-elements';
import './Qna.css';


class Qna extends Component {
    constructor(props) {
        super(props)
        this.state = {
            body_class: ['apps-gotlocked-order', 'apps-gotlocked-qna']
        }
    }

    componentWillMount() {
        setTimeout(function() {
            if (document.body.classNameList) {
                document.body.classNameList.add(...this.state.body_class);
            } else {
                document.body.className = this.state.body_class.join(' ');
            }
            //document.getElementById('apps-gotlocked-menu').style.display = 'none';
        }.bind(this), 1);
    }
    
    componentWillUnmount() {
        document.body.className = '';
    }

    render() {
        return (
            <div>
                <section className="apps-gotlocked-faq-section section-padding" id="apps-gotlocked-faq">
                        <div className="container">
                            <Row>
                                <Col>
                                    <div className="apps-gotlocked-order-tbl-c">
                                        <div className="apps-gotlocked-order-content text-center">
                                            <h1>GotLocked Questions Section</h1>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                            <br /><br />
                            <Row>
                                <Col>
                                    <div className="apps-gotlocked-accordion wow fadeIn" data-wow-delay="100ms">
                                        <div className="panel-group" id="accordion">
                                            <div className="panel panel-default">
                                                <div className="panel-heading">
                                                    <h4 className="panel-title click">
                                                        <a data-toggle="collapse" data-parent="#accordion" href="#collapse1" className="">
                                                        Benefit of the App and how it works </a>
                                                    </h4>
                                                </div>
                                                <div id="collapse1" className="panel-collapse collapse in">
                                                    <div className="panel-body">By submitting your information once, you will be able to have multiple technicians bid for your business.<br />
                                                        Due the fact that you will be able to communicate to the technicians directly, you will save your precious<br />
                                                        time and spare yourself from the hassle of annoying solicitation calls.<br />
                                                        You can choose your ideal technician by reading the reviews and comments, finding the relevant price,<br />
                                                        convenient eta and what suits personally you. Book the service only after you find a provider which<br />
                                                        best meets your needs.<br />
                                                        We want our customer to have a clear view on what they are getting. Be in control and save time.</div>
                                                </div>
                                            </div>
                                            <div className="panel panel-default">
                                                <div className="panel-heading">
                                                    <h4 className="panel-title">
                                                        <a data-toggle="collapse" data-parent="#accordion" href="#collapse2" className="collapsed">About customer service</a>
                                                    </h4>
                                                </div>
                                                <div id="collapse2" className="panel-collapse collapse">
                                                    <div className="panel-body">
                                                        Our goal is to have happy and satisfied customers, and make the process of getting a locksmith easy,<br />
                                                        safe, and affordable. All of our sub – contactors are highly professional technicians that are highly<br />
                                                        trained to provide you with top-notch guaranteed locksmith service, however in case if you have any<br />
                                                        additional questions, you can always refer to our caring 24/7 customer service.
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="panel panel-default">
                                                <div className="panel-heading">
                                                    <h4 className="panel-title">
                                                        <a data-toggle="collapse" data-parent="#accordion" href="#collapse3" className="collapsed">About techs</a>
                                                    </h4>
                                                </div>
                                                <div id="collapse3" className="panel-collapse collapse">
                                                    <div className="panel-body">All of our sub-contractors are fully licensed, certified and insured locksmith technicians with the skills and know-how to help you. </div>
                                                </div>
                                            </div>
                                            <div className="panel panel-default">
                                                <div className="panel-heading">
                                                    <h4 className="panel-title">
                                                        <a data-toggle="collapse" data-parent="#accordion" href="#collapse4" className="collapsed">List of services </a>
                                                    </h4>
                                                </div>
                                                <div id="collapse4" className="panel-collapse collapse">
                                                    <div className="panel-body">Our expert sub – contractors provide automative, residential and commercial locksmith services on site.</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                </section>
            </div >
        );
    }
}

export default Qna;